import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { Motif } from "./Motif";

export const LegalPage = ({ label, title, updated, sections }) => {
  const navigate = useNavigate();
  return (
  <section
    data-testid="legal-page"
    className="relative overflow-hidden pt-32 md:pt-40 pb-20 md:pb-32"
  >
    <div className="pointer-events-none absolute -left-40 top-24 w-[520px] h-[520px] -z-10">
      <Motif opacity={0.12} />
    </div>
    <div className="pointer-events-none absolute right-[-6rem] bottom-[-4rem] w-[360px] h-[360px] -z-10">
      <Motif opacity={0.09} flip />
    </div>

    <div className="max-w-3xl mx-auto px-5 md:px-8">
      <Reveal>
        <SectionLabel className="mb-6">{label}</SectionLabel>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-kern-dark">
          {title}
        </h1>
        {updated && <p className="mt-5 text-sm text-kern-taupe">{updated}</p>}
      </Reveal>

      <div className="mt-10 md:mt-14 space-y-8 md:space-y-10">
        {sections.map((s, i) => (
          <Reveal key={s.h} delay={i * 0.03}>
            <h2 className="font-serif text-xl md:text-2xl text-kern-dark leading-snug">
              {s.h}
            </h2>
            <div className="mt-3 space-y-3 text-sm md:text-base text-kern-taupe leading-relaxed">
              {s.p.map((p, j) => (
                <p key={j}>{p}</p>
              ))}
              {s.link && (
                <button
                  data-testid={`legal-link-${i}`}
                  onClick={() => navigate(s.link.to)}
                  className="inline-flex items-center gap-2 mt-1 text-sm font-medium text-kern-terracotta hover:gap-3 transition-all duration-300"
                >
                  {s.link.text}
                  <ArrowRight size={16} />
                </button>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
